import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BaseApi, BASE_URL } from '@edl-development/edl-common';
import { ObservationSummaryDTO } from '../model/observation/observation-summary-dto.model';
import { SloObservationDetails } from '../model/observation/slo/slo-details.model';
import { SloPerformanceIndicator } from '../model/observation/slo/slo-performance-indicator.model';
import { SloPerformanceMeasure } from '../model/observation/slo/slo-performance-measure.model';

@Injectable()
export class SloApi extends BaseApi {

  constructor(
    @Inject(BASE_URL) private baseUri: string,
    private http: HttpClient
  ) {
    super();
  }

  getObservationDetails(observationId: string) {
    return this.http.get(this.baseUri + '/observation/slo/' + observationId, {});
  }

  createSlo(observation: SloObservationDetails) {
    return this.http.post<ObservationSummaryDTO>(this.baseUri + '/observation/slo/create', observation);
  }

  //hooks
  saveSLO(slo: SloObservationDetails) {
    return this.http.put(this.baseUri + '/observation/slo/update', slo);
  }
  completeInitial(slo: SloObservationDetails) {
    return this.http.put(this.baseUri + '/observation/slo/completeInitial', slo);
  }
  completeFinalization(slo: SloObservationDetails) {
    return this.http.put(this.baseUri + '/observation/slo/completeFinalization', slo);
  }
  approve(slo: SloObservationDetails) {
    return this.http.put(this.baseUri + '/observation/slo/approve', slo);
  }
  requestUpdate(sloId: string) {
    return this.http.post(this.baseUri + '/observation/slo/requestUpdate/'+sloId, null);
  }
  finalizeSLO(slo: SloObservationDetails) {
    return this.http.put(this.baseUri + '/observation/slo/finalize', slo);
  }



  // PMs
  createPM(sloId: string, performanceMeasure: SloPerformanceMeasure) {
    return this.http.post(this.baseUri + '/observation/slo/' + sloId + '/pm/create', performanceMeasure, { responseType: "text" });
  }

  updatePM(performanceMeasure: SloPerformanceMeasure) {
    return this.http.put(this.baseUri + '/observation/slo/pm/update', performanceMeasure);
  }

  deletePM(performanceMeasureId: number) {
    return this.http.delete(this.baseUri + '/observation/slo/pm/' + performanceMeasureId + '/delete');
  }

  // PIs  
  createPI(performanceIndicator: SloPerformanceIndicator) {
    return this.http.post(this.baseUri + '/observation/slo/pi/create', performanceIndicator, { responseType: "text" });
  }

  updatePI(performanceIndicator: SloPerformanceIndicator) {
    return this.http.put(this.baseUri + '/observation/slo/pi/update', performanceIndicator);
  }

  deletePI(performanceIndicatorId: number) {
    return this.http.delete(this.baseUri + '/observation/slo/pi/' + performanceIndicatorId + '/delete');
  }

  // SLO Comments
  getSloComments(sloId: string) {
    return this.http.get(this.baseUri + '/observation/slo/' + sloId + '/sloComments');
  }
  
  rollbackSloState(sloId: string, newState: number){
    return this.http.put(this.baseUri + '/observation/slo/' + sloId + '/state/' + newState, null);
  }
}
